import React from "react";
import { useAppearance } from "../../context/AppearanceContext";

// A calm, per-theme edge vignette. It tints only the extreme edges of the viewport in the active
// theme's mood colour so it is instantly clear a season is on, while the central reading canvas
// stays pristine. Purely cosmetic, non-interactive, and suppressed when decorative effects are off.
// Winter is special: crisp icy blue along the top, a warm indoor amber glow in the bottom corners.
export default function SeasonalFrame() {
  const { theme, prefs } = useAppearance();
  if (!prefs.ambient || !theme || theme.id === "default") return null;
  return <div className="pl-frame" aria-hidden="true" data-testid="seasonal-frame" />;
}
